import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const Footer = () => (
  <footer className="bg-[#12151f] border-t border-[#232a3d]" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div>
          <Logo size="md" />
          <p className="mt-4 uppercase text-[11px] font-bold tracking-[0.2em] text-[#7e879c] max-w-xs leading-relaxed">
            gambling, Lifestyle, gaming and more — enjoy!
          </p>
          <p className="mt-6 text-[12px] text-[#5d6579]">
            © {new Date().getFullYear()} WAXUM.GG — All rights reserved
          </p>
        </div>

        <nav className="flex flex-col gap-3">
          <Link to="/" className="uppercase text-[12px] font-bold tracking-widest text-[#97a1b8] hover:text-[#3ddc84] transition-colors duration-200">
            Home
          </Link>
          <Link to="/leaderboard" className="uppercase text-[12px] font-bold tracking-widest text-[#97a1b8] hover:text-[#3ddc84] transition-colors duration-200">
            Leaderboard
          </Link>
          <a
            href="#bonuses"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("bonuses")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="uppercase text-[12px] font-bold tracking-widest text-[#97a1b8] hover:text-[#3ddc84] transition-colors duration-200"
          >
            Claim Bonus
          </a>
        </nav>
      </div>

      <div className="mt-12 pt-6 border-t border-[#232a3d]">
        <p className="text-[11px] leading-relaxed text-[#5d6579] max-w-3xl">
          We do not take responsibility for any losses from gambling in casinos and betting
          sites which are linked or promoted on our website(s). As a player, you are
          responsible for your bets. 18+ only. Please gamble responsibly.
        </p>
        <p className="mt-5 text-[12px] text-[#5d6579]">
          Made By{" "}
          <a
            href="https://raff.buzz"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-[#97a1b8] hover:text-[#3ddc84] transition-colors duration-200"
            data-testid="made-by-raff"
          >
            Raff
          </a>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
